export const AppPageTitlesEnum = {
    CKM_AG: 'YX Admin - CheckMate - AG',
    CKM_AG_SUBMIT_RETEST: 'YX Admin - Submit Retest',
    CKM_AG_START_INVESTIGATION: 'YX Admin - Start Investigation',
    CKM_SEQ: 'YX Admin - CheckMate - Sequencing',

    STRAIN_LISTING: 'YX Admin - Strain Listing',
    STRAIN_COPY: 'YX Admin - Strain Copy',
    STRAIN_OVERVIEW: 'YX Admin - Strain Overview',
    STRAIN_MESSAGES: 'YX Admin - Strain Messages',
    STRAIN_NOTES: 'YX Admin - Strain Notes',
    STRAIN_TRANSLATIONS: 'YX Admin - Strain Translations',
    STRAIN_SIF: 'YX Admin - Strain SIF',

    ASSAY_LISTING: 'YX Admin - Assay Listing',
    ASSAY_CONSTRUCTS: 'YX Admin - Assay Constructs',
    ASSAY_PROBE_MANUFACTURING: 'YX Admin - Assay Probe Manufacturing',
    ASSAY_SEQUENCING: 'YX Admin - Assay Sequencing',
    ASSAY_OVERVIEW: 'YX Admin - Assay Overview',
    ASSAY_MODIFY_DETAILS: 'YX Admin - Assay Modify Details',
    ASSAY_PROBES: 'YX Admin - Assay Probes',
    ASSAY_DOC: 'YX Admin - Assay Doc',
    ASSAY_NOTES: 'YX Admin - Assay Notes',
    ASSAY_LOG: 'YX Admin - Assay Log',
    ASSAY_SIF: 'YX Admin - Assay SIF',
    ASSAY_CONSTRUCT_OVERVIEW: 'YX Admin - Construct Overview',
    ASSAY_CONSTRUCT_STRAINS: 'YX Admin - Construct Strains',
    ASSAY_ORDER_PCR_PRODUCT: 'YX Admin - Order PCR Product',

    ACCOUNT_LISTING: 'YX Admin - Account Listing',
    ACCOUNT_OVERVIEW: 'YX Admin - User Overview',
    ACCOUNT_CONTACTS: 'YX Admin - User Contacts',
    ACCOUNT_DISCOUNTS: 'YX Admin - User Discounts',
    ACCOUNT_MESSAGES: 'YX Admin - User Messages',
    ACCOUNT_MODIFY: 'YX Admin - User Modify',
    ACCOUNT_NOTES: 'YX Admin - User Notes',
    ACCOUNT_ROLES: 'YX Admin - User Roles',

    PROBE_LISTING: 'YX Admin - Probe Listing',
    PROBE_INCOMPATIBLE_PROBES: 'YX Admin - Incompatible Probes',
    PROBE_MANUFACTURING: 'YX Admin - Probe Manufacturing',
    PROBE_ABI_FILE_IMPORT: 'YX Admin - ABI File Import',
    PROBE_OVERVIEW: 'YX Admin - Probe Overview',
    PROBE_MODIFY_DETAILS: 'YX Admin - Probe Modify Details',
    PROBE_REDESIGN: 'YX Admin - Probe Redesign',
    PROBE_ORDER_HISTORY: 'YX Admin - Probe Order History',
    PROBE_SEQUENCING: 'YX Admin - Probe Sequencing',
    PROBE_STRAINS: 'YX Admin - Probe Strains',
    PROBE_SCHEDULE_RETESTS: 'YX Admin - Probe Schedule Retests',
};
